import * as angular from "angular";
import { APP_SHELL_STATE } from './../app-shell.route';
import { StateProvider, UrlRouterProvider } from "@uirouter/angularjs";
import { DashboardService, DASHBOARD_SERVICE } from './dashboard.service';
import { DashboardController } from './dashboard.controller';
import { ManageController } from '../manage/manage.controller';
import { ManageService, MANAGE_SERVICE } from '../manage/manage.service';
import { MonitorService, MONITOR_SERVICE } from './../monitor/monitor.service';
import { HeaderService, HEADER_SERVICE } from './../core/header.service';
import { dashboardComponent } from "./dashboard.component";
import { registerComponentFromTransition } from "../core/lazy-route.helper";

export const DASHBOARD_STATE = "dashboard";

export function configRoute($stateProvider: StateProvider, $urlRouterProvider: UrlRouterProvider) {

    $stateProvider.state(DASHBOARD_STATE, {
        parent: APP_SHELL_STATE,
        url: "/dashboard",
        views: {
            content: {
                component: "dashboardComponent",
                bindings: {
                    series: "series",
                    services: "services",
                    processorId: "processorId",
                    machineName: "machineName",
                    settings: "settings"
                }
            }
        },
        lazyLoad: (transition, state) => {
            return System.import("./dashboard.component").then(moduleExports => {
                registerComponentFromTransition(transition, "dashboardComponent", moduleExports.dashboardComponent);
                return moduleExports;
            });
        },
        onExit: [MONITOR_SERVICE, (monitorService: MonitorService) => {
            return monitorService.start.then(() => {
                monitorService.hub.server.stopChartsTimer();
                monitorService.hub.server.stopStatusTimer();
            });
        }],
        onEnter: [HEADER_SERVICE, (headerService: HeaderService) => {
            headerService.headerTitle = "System Health Dashboard"
        }],
        resolve: {
            series: [DASHBOARD_SERVICE, (dashboardService: DashboardService) => {
                return dashboardService.servicesToWatch();
            }],
            services: [MANAGE_SERVICE, (manageService: ManageService) => {
                return manageService.servicesToWatch();
            }],
            startTimer: [MONITOR_SERVICE, (monitorService: MonitorService) => {
                return monitorService.start.then(() => {
                    monitorService.hub.server.startChartsTimer();
                    monitorService.hub.server.startStatusTimer();
                });
            }],
            processorId: [DASHBOARD_SERVICE, (dashboardService: DashboardService) => {
                return dashboardService.processorId().then((response) => {
                    return response;
                });
            }],
            machineName: [DASHBOARD_SERVICE, (dashboardService: DashboardService) => {
                return dashboardService.machineName().then((response) => {
                    return response;
                });
            }],
            settings: [DASHBOARD_SERVICE, (dashboardService: DashboardService) => {
                return dashboardService.instanceSettings().then((response) => {
                    return response;
                });
            }]
        }
    });
}
configRoute.$inject = ["$stateProvider", "$urlRouterProvider"];


// WEBPACK FOOTER //
// ./app/dashboard/dashboard.router.ts